import { InjectionToken, Injector, NgModule } from "@angular/core";
import { APP_BASE_HREF, CommonModule } from "@angular/common";
import { Routes, RouterModule, ActivatedRouteSnapshot, PreloadAllModules } from "@angular/router";

import { detailedRoutes } from "./_constants/detailed.routes";
import { OKTA_CONFIG } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import config from './app.config';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forRoot(detailedRoutes, {
			preloadingStrategy: PreloadAllModules,
			useHash: false,
			scrollPositionRestoration: "enabled",
			anchorScrolling: "enabled",
			scrollOffset: [0, 64],
			enableTracing: false,
		}),
	],
	exports: [RouterModule],
	providers: [
		{
			provide: externalUrlProvider,
			useValue: (route: ActivatedRouteSnapshot) => {

				const externalUrl = route.paramMap.get('externalUrl');
				window.open(externalUrl, '_self');
			},
		},
		{ 
			provide: OKTA_CONFIG, 
			useFactory: () => {
			  const oktaAuth = new OktaAuth(config.oidc);
			  return {
				oktaAuth,
				onAuthRequired: (oktaAuth: OktaAuth, injector: Injector) => {
				  const triggerLogin = async () => {
					localStorage.clear();
					await oktaAuth.signInWithRedirect({ originalUri: '/' });
				  };
				  if (!oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated) {
					// App initialization stage
					triggerLogin();
				  }
				}  
			  }
			}
		  },
		  { provide: APP_BASE_HREF, useValue: "/" }
	]

})
export class AppRoutingModule {}
